/* eslint react-hooks/exhaustive-deps: "warn" */

import { ReactNode } from 'react';

import cn from 'classnames';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './UseCases.module.scss';

export type DataCases = {
  title: string;
  description: string;
  icon: string;
};

type Props = {
  extra?: string;
  title?: string;
  description?: string;
  layout: 'grid-3-1' | 'grid-3-2' | 'grid-3-3' | 'grid-2-3' | 'grid-2-2';
  dataCases: DataCases[];
  actionBlock?: ReactNode;
  className?: string;
  largeIcons?: boolean;
  hasHover?: boolean;
  theme?: 'dark' | 'light';
  iconPosition?: 'left' | 'right';
  background?: string;
  round?: 'top' | 'bottom' | 'both';
  introBlockFullWidth?: boolean;
};

const baseClass = 'use-cases';

export const UseCases = ({
  extra,
  title,
  description,
  dataCases,
  layout,
  actionBlock,
  className,
  largeIcons,
  hasHover,
  theme = 'dark',
  iconPosition = 'left',
  background,
  round,
  introBlockFullWidth,
}: Props) => {
  const isRightIcon = iconPosition === 'right' && !largeIcons;

  return (
    <section
      className={cn(
        styles[`${baseClass}-wrapper`],
        styles[`${baseClass}-${theme}`],
        round && styles[`${baseClass}-round-${round}`],
        className,
      )}
      style={background ? { background } : undefined}
    >
      <div className={styles[`${baseClass}-container`]}>
        {(title || description || extra) && (
          <TitleBlock
            extra={extra}
            title={title}
            description={description}
            fullWidth={introBlockFullWidth}
            theme={theme}
          />
        )}

        <div className={cn(styles[`${baseClass}-cards`], styles[`${baseClass}-cards-${layout}`])}>
          {dataCases.map((item, idx) => (
            <div
              key={idx}
              className={cn(
                styles[`${baseClass}-card`],
                hasHover === false && styles[`${baseClass}-card-no-hover`],
                isRightIcon && styles[`${baseClass}-card-icon-right`],
              )}
            >
              {largeIcons && (
                <div className={styles[`${baseClass}-card-icon-large-wrapper`]}>
                  <Icon type={item.icon} className={styles[`${baseClass}-card-icon-large`]} />
                </div>
              )}

              {isRightIcon ? (
                <>
                  <div className={styles[`${baseClass}-card-body`]}>
                    <p>{item.title}</p>
                    <span>{item.description}</span>
                  </div>
                  <Icon type={item.icon} className={styles[`${baseClass}-card-icon`]} />
                </>
              ) : (
                <>
                  <div className={styles[`${baseClass}-card-header`]}>
                    {!largeIcons && <Icon type={item.icon} className={styles[`${baseClass}-card-icon`]} />}
                    <p>{item.title}</p>
                  </div>
                  <span>{item.description}</span>
                </>
              )}
            </div>
          ))}
        </div>

        {actionBlock && <div className={styles[`${baseClass}-action-block`]}>{actionBlock}</div>}
      </div>
    </section>
  );
};
